import * as React from 'react';
import PageContainer from "@components/PageContainer";
import { Link } from 'react-router-dom';
import Block from "@layout/Block";
import Font from "@layout/Font";
import './index.scss';

interface Props { }

const Footer = (props: Props) => (
    <div className="footer">
        <Block indent="20">
            <hr className="line" />
        </Block>
        <div className="wrapper">
            <Font font="primary" size={20} lineHeight={1.8}>
                Get in contact
            </Font>
            <Font font="secondary" size={15} lineHeight={1.4}>
                via email at <a className="link hvr-sweep-to-right" href="mailto:hello@nick.engineering">hello@nick.engineering</a> or via <Link className="link hvr-sweep-to-right" to="/contact">contact form</Link>
            </Font>
        </div>
    </div>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Contact/index.tsx